<template>
  <div>
    <div>
      <md-radio
        :model="selectMode"
        @change="$emit('update:selectMode', $event)"
        value="item"
      >
        商品
        <gl-sub-text>で指定</gl-sub-text>
      </md-radio>
      <md-radio
        :model="selectMode"
        @change="$emit('update:selectMode', $event)"
        value="category"
      >
        分類
        <gl-sub-text>で指定</gl-sub-text>
      </md-radio>
    </div>
    <filter-item
      v-if="company && selectMode === 'item'"
      :company="company"
      v-bind.sync="item"
    />
    <filter-item-category
      v-if="selectMode === 'category'"
      :company="company"
      v-bind.sync="item"
    />
    <div>
      <gl-switch
        :value="excludeNonActive"
        @input="$emit('update:excludeNonActive', $event)"
        :disabled="isExcludeNonActiveDisabled"
      >
        実績がない商品/分類を結果から除外する
      </gl-switch>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

import FilterItem from '@/components/FilterItem.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'

export default {
  mixins: [ErrorReport],
  components: {
    FilterItem,
    FilterItemCategory,
  },
  props: {
    company: {
      type: String,
    },
    selectMode: {
      type: String,
      required: true,
    },
    item: {
      items: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    excludeNonActive: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isExcludeNonActiveDisabled() {
      // 単品の明示的な指定では実績0を含める
      return this.selectMode === 'item'
    },
    errors() {
      const errors = []

      if (this.selectMode === 'item' && this.item.items.length === 0) {
        errors.push('商品を選択してください。')
      }

      if (this.selectMode === 'category' && this.item.categories.length === 0) {
        errors.push('分類を選択してください。')
      }

      return errors
    },
  },
  watch: {
    selectMode(selectMode) {
      if (selectMode === 'item') {
        this.$emit('update:excludeNonActive', false)
      } else if (selectMode === 'category') {
        this.$emit('update:excludeNonActive', true)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}
</style>
